import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';

import { cx } from '@emotion/css';
import { Category, Post, Tag } from '@lib/wordpress.d';
import { HOME_ROUTES } from '@util/constants';

import {
  GetPostCategories,
  GetPostDetails,
  getPostFeaturedMedia,
  getPostReadTime,
  getPostSubmitted,
  GetPostTags,
  GetPostTitle,
} from '../util';

type Props = {
  styles: any;
  post: Post;
  categories: Category[];
  tags: Tag[];
};
export const Card = (props: Props) => {
  const { styles, post, categories, tags } = props;
  const router = useRouter();

  const url: string = getPostFeaturedMedia({ post });
  const altText: string = url?.split('/').pop() || 'featured image';

  const selectTag = (ev: any, selectedTag: Tag) => {
    ev.stopPropagation();

    router.push({
      pathname: router.pathname,
      query: { tag: selectedTag.id },
    });
  };

  const gotoBlog = () => {
    router.push(`${HOME_ROUTES.BLOG_DETAILS}${post.slug}`);
  };

  return (
    <div
      className={cx(styles.article_card, styles.sm_blog_cards)}
      onClick={gotoBlog}>
      <div className={cx(styles.article_image, styles.sm_blog_image)}>
        <Image
          className={styles.article_img}
          width={0}
          height={0}
          sizes="100vw"
          src={getPostFeaturedMedia({ post })}
          alt={altText}
          loading="lazy"
          priority={false}
        />
      </div>
      <div className={cx(styles.article_details, styles.sm_blog_details)}>
        <GetPostCategories
          categoryIds={post.categories}
          categories={categories}
          style={styles.card_tag}
        />
        <GetPostTags
          tagIds={post.tags}
          tags={tags}
          style={styles.card_tag}
          getSelectedTag={(clickEvent: any, e: Tag) => selectTag(clickEvent, e)}
        />
        <div className={styles.card_title_Arrow}>
          <h6
            className={cx(styles.card_title, styles.sm_card_title, styles.h6)}>
            <GetPostTitle post={post} />
          </h6>
        </div>
        <div
          className={cx(styles.card_description, styles.sm_blog_description)}>
          <GetPostDetails post={post} />
        </div>
        <div className={styles.card_date_time}>
          <ul className={styles.card_date_time_ul}>
            <li className={styles.card_date_time_li}>
              <span className={styles.card_icons}>
                <Image
                  src={'/images/blog/list/calendar.svg'}
                  className={styles.card_icons_img}
                  width={18}
                  height={18}
                  alt="calendar"
                />
              </span>
              {getPostSubmitted({ post })}
            </li>
            <li className={styles.card_date_time_li}>
              <span className={styles.card_icons}>
                <Image
                  src={'/images/blog/list/time.svg'}
                  className={styles.card_icons_img}
                  width={18}
                  height={18}
                  alt="time"
                />
              </span>
              {getPostReadTime({ post })}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
